import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import * as firebase from 'firebase';
import 'firebase/firestore';
import {ToastService} from '../typescripts/pro/alerts'

@Component({
  selector: 'app-adminextraescolares-crear',
  templateUrl: './adminextraescolares-crear.component.html',
  styleUrls: ['./adminextraescolares-crear.component.scss']
})
export class AdminextraescolaresCrearComponent implements OnInit {

  state = 'crear';
  objectId;
  user;
  userId;
  ampa;

  imagen = 'https://firebasestorage.googleapis.com/v0/b/miampa-1be3e.appspot.com/o/compartido%2Fdefault-image.png?alt=media&token=1486414d-b17d-4789-a148-11c226f96c20';
  nombre;
  descripcion;
  precio;
  nivel;
  empresa;

  empresas = [];
  niveles = [];
  selectedEmpresa;
  selectedNivel;

  optionsSelectNivel = [];
  optionsSelectEmpresa = [];

  selectedfilename;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private toast: ToastService
  ) {
    this.userId = localStorage.getItem('userId');
    console.log('UserId', this.userId);
    if(!this.userId){
      this.router.navigate[('')]
    } else {
      firebase.firestore().collection('admins').doc(this.userId)
      .get()
      .then((doc)=>{

        this.user = doc.data();
        console.log('User extraescolar crear', this.user)

        this.rellenarSelectNiveles();
        this.rellenarSelectEmpresas();

        this.state = 'crear';
        this.route.params.subscribe(params => {
          if(params.state){
            if(params.state === 'editar'){
              this.state = 'editar';
              this.objectId = params.id
            } else if(params.state === 'ver'){
              this.state = 'ver';
              this.objectId = params.id
            }
            else
              this.state = 'crear';

            this.cargarDatos(this.objectId)
          }
          console.log('params state: ', this.state)
          console.log('params state: ', params.state)
          console.log('params id: ', params.id)
        })

      })
      .catch((error)=>{
        console.log('Hay un error:', error)
      })




  }

}

  ngOnInit() { }


  rellenarSelectNiveles(){
    console.log('rellenarSelectNiveles')
    firebase.firestore().collection('niveles')
    //.where('ampa','==', this.user.ampa)
    .get()
    .then((snapshot)=>{
      snapshot.forEach((doc)=>{
        console.log('doc',doc)
        var elemento = doc.data();
        elemento.id = doc.id;
        this.niveles = [...this.niveles,elemento];


        var objeto = {
          value: elemento.id,
          label: elemento.nombre
        }
        //hacemos el push
        this.optionsSelectNivel = [...this.optionsSelectNivel, objeto];
      })
      console.log('fin selectNivel')
      console.log('optionsSelectNivel', this.optionsSelectNivel)
      console.log('this.niveles', this.niveles)
    })
    .catch(err => {
        console.log('Error rellenarSelectEmpresas', err);
    });
  }

  rellenarSelectEmpresas(){
    console.log('user?', this.user)
    console.log('rellenarSelectEmpresas')
    firebase.firestore().collection('empresas')
    .where('ampa','==', this.user.ampa)
    .get()
    .then((snapshot)=>{
      snapshot.forEach((doc)=>{
        var elemento = doc.data();
        console.log('rellenarSelectEmpresas doc', elemento)
        elemento.id = doc.id;
        this.empresas = [...this.empresas,elemento];

        var objeto = {
          value: elemento.id,
          label: elemento.nombre
        }
        //hacemos el push
        this.optionsSelectEmpresa = [...this.optionsSelectEmpresa, objeto];
      })
      console.log('fin forEach selectEmpresa')
      console.log('optionsSelectEmpresa', this.optionsSelectEmpresa)
      console.log('this.empresas', this.empresas)
    })
    .catch(err => {
        console.log('Error rellenarSelectEmpresas', err);
    });
  }

  //guardar los datos del elemento creado
  guardar(){
    var now = new Date()

    // asignamos los datos de extraescolar combinados (datos extraescolar + datos nivel + datos empresa )
    // para poder leerlos facilmente en la tabla extraescolares
    firebase.firestore().collection('extraescolares').add({
      date_registered: now || '',
      ampa: this.user.ampa || '',
      imagen: this.imagen || '',
      nombre: this.nombre || '',
      descripcion: this.descripcion || '',
      precio: this.precio || '',
      nivel: this.selectedNivel || '',
      empresa: this.selectedEmpresa || '',
    })
    .then((docRef)=>{
      if (docRef)
        console.log('Creado ', docRef.id)
      this.showSuccess('Datos guardatos correctamente.');
      this.router.navigate(['/admin/extraescolares'])
    })
    .catch(err => {
        console.log('Error getting documents', err);
    });
  }

  cargarDatos(id){
    firebase.firestore().collection('extraescolares').doc(id)
    .get()
    .then((doc)=>{
      var elemento = doc.data();
      console.log('asignado doc.data a elemento ',elemento)

      this.imagen = elemento.imagen;
      this.nombre = elemento.nombre;
      this.descripcion = elemento.descripcion;
      this.precio = elemento.precio;
      this.nivel = elemento.nivel;
      this.selectedNivel = elemento.nivel;
      this.empresa = elemento.empresa;
      this.selectedEmpresa = elemento.empresa;
      console.log('asignado nivel',elemento.nivel)
      console.log('asignada empresa',elemento.empresa)



    })
  }

  volver(){
    this.router.navigate(['/admin/extraescolares'])

  }
  editar(){
    var now = new Date()
    firebase.firestore().collection('extraescolares').doc(this.objectId).update({
      date_registered: now || '',
      ampa: this.user.ampa || '',
      imagen: this.imagen || '',
      nombre: this.nombre || '',
      descripcion: this.descripcion || '',
      precio: this.precio || '',
      nivel: this.nivel.nombre || '',
      empresa: this.empresa.nombre || '',
    })
    .then((docRef)=>{
      if (docRef)
        console.log('Creado ', docRef);
      this.showSuccess('Datos guardatos correctamente.');
      this.router.navigate(['/admin/extraescolares']);
    })
  }

  selectedFile(fileInput: Event){

    let target = <HTMLInputElement>fileInput.target;
    let files = target.files;
    let file = files.item(0);

    var storage = firebase.storage();
    var storageRef = storage.ref();

    var imagesRef = storageRef.child('ampas/'+ this.user.ampa + '/' + file.name );
    this.selectedfilename = file.name;
    imagesRef.put(file)
    .then((snapshot)=>{
      this.imagen = snapshot.downloadURL;
    })
  }

  //metodos de toast para el usuario
  showSuccess(mensaje) {
    //let options = { closeButton: true, tapToDismiss: false,  titleClass: 'yellow' };
    //this.toast.success(mensaje, 'Toastr success!', options);
    this.toast.success(mensaje);
  }

  showError(mensaje) {
    //let options = { enableHtml: false,  positionClass: 'toast-bottom-right' };
    //this.toast.error(mensaje, 'Toastr error!', options);
    this.toast.error(mensaje);
  }

  showInfo(mensaje) {
    //let options = { extendedTimeOut: 30000, messageClass: 'pink' };
    //this.toast.info('Info message', 'Toastr info!', options);
    this.toast.info(mensaje);
  }

  showWarning(mensaje) {
    //let options = { progressBar: true,  timeOut: 3000,  toastClass: 'black'};
    //this.toast.warning('Warnig message', 'Toastr warning!', options);
    this.toast.warning(mensaje);
  }


  extreaescolaresCrearNivelSeleccionado(event){
    console.log('Event', event);
    var obj = this.niveles.find(o => o.id === event);
    this.selectedNivel = obj;
    console.log('Nivel seleccionado?', this.selectedNivel);
  }

  extreaescolaresCrearEmpresaSeleccionado(event){
    console.log('Event', event);
    var obj = this.empresas.find(o => o.id === event);
    this.selectedEmpresa = obj;
    console.log('Empresa seleccionada?', this.selectedEmpresa);
  }

}



// WEBPACK FOOTER //
// ./src/app/adminextraescolares-crear/adminextraescolares-crear.component.ts